/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualTaxDto } from '../../models/backend-actual-tax-dto';
import { BackendActualTaxRequestDto } from '../../models/backend-actual-tax-request-dto';

export interface MonitoringActualsTaxesUpdate$FormData$Params {
  id: number;
  body: BackendActualTaxRequestDto;
}

export function monitoringActualsTaxesUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsTaxesUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualTaxDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsTaxesUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualTaxDto>;
    }),
  );
}

monitoringActualsTaxesUpdate$FormData.PATH = '/api/monitoring/actuals/taxes/{id}/';
